import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "cc_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, sizeLabel, qty = 1, options = {}) => {
    setItems((prev) => {
      const optKey = [options.length, options.color, options.thickness].filter(Boolean).join("|");
      const key = `${product.id}:${sizeLabel || ""}:${optKey}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      }
      const size = product.sizes?.find((s) => s.label === sizeLabel);
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          image: product.images?.[0] || "",
          size_label: sizeLabel || null,
          options,
          made_to_order: product.made_to_order || product.category === "Locs Extensions",
          qty,
          unit_price_cents: size ? size.price_cents : product.sale_price_cents || product.price_cents,
        },
      ];
    });
  };

  const setQty = (key, qty) => {
    if (qty < 1) return;
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clearCart = () => setItems([]);

  const subtotalCents = items.reduce((sum, i) => sum + i.unit_price_cents * i.qty, 0);
  const count = items.reduce((sum, i) => sum + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, setQty, removeItem, clearCart, subtotalCents, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
